// export const BaseURL = "https://dev.taxinminutes.com";
export const BaseURL = process.env.REACT_APP_BASE_URL;
